import { jsx as _jsx } from "react/jsx-runtime";
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
export const NotificationDetailError = ({ NOTIFICATIONS_ERROR }) => {
    return (_jsx(CatInlineNotification, { variant: "error", heading: NOTIFICATIONS_ERROR, dismissible: false, "data-testid": "ErrorIcon", children: _jsx(CatIconWarningCircle, { slot: "before" }) }));
};
